import React, { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { Layout } from 'antd'

import SessionService from '../../core/session'

import { childRoutes } from '../../router'

import NavHeader from './NavHeader'
import Sidebar from './SidePanel/Index'

const { Content } = Layout

const sessionService = SessionService.Instance()

type Props = {
  location: any
}

class Home extends Component<Props> {
  render() {
    const defaultPage = '/machine/list'
    let redirect = null
    if (!sessionService.isLogin()) {
      redirect = <Redirect to="/login" />
    } else if (this.props.location && this.props.location.pathname === '/') {
      redirect = <Redirect to={defaultPage} />
    }

    return (
      <div className="main-page">
        <Layout className="main-body">
          <NavHeader />
          <Layout style={{ margin: '60px 0 0' }}>
            <Sidebar location={this.props.location} defaultPage={defaultPage} />
            <Layout className="body-content">
              <Content>
                {/* <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>content</div> */}
                {redirect}
                {childRoutes.map((route, index) => {
                  return (
                    <Route
                      key={index}
                      path={route.path}
                      component={route.component}
                      exact={route.exactly}
                    />
                  )
                })}
              </Content>
              {/* <Footer style={{ textAlign: 'center' }}>
                极链云 ©2020 Created by VideoJJ
              </Footer> */}
            </Layout>
          </Layout>
        </Layout>
      </div>
    )
  }
}

export default Home
